import React from "react";
import PropTypes from "prop-types";

const SliderImage = (props) => {
    const top  = !isNaN(props.top) ? props.top : 0;
    const left = !isNaN(props.left) ? props.left : 0;
    const rotate = !isNaN(props.rotate) ? props.rotate : 0;
    const src= props.src ? props.src : "https://wedesignthemes.com/html/kidslife/images/layerslider-gallery/common-swirl.png";
    const alt = props.alt ? props.alt : "";
    const offsetxin = !isNaN(props.offsetxin) ? props.offsetxin : 0;
    const offsetyin = !isNaN(props.offsetyin) ? props.offsetyin : 0;
    const offsetxout = !isNaN(props.offsetxout) ? props.offsetxout : 0;
    const offsetyout = !isNaN(props.offsetyout) ? props.offsetyout : 0;
    const delayin = !isNaN(props.delayin) ? props.delayin : 0;
    const parallaxlevel = !isNaN(props.parallaxlevel) ? props.parallaxlevel : 4;
    const rotatexin = !isNaN(props.rotatexin) ? props.rotatexin : 0;
    const rotateyin = !isNaN(props.rotateyin) ? props.rotateyin : 0;
    const scalexin = !isNaN(props.scalexin) ? props.scalexin : 1;
    const scaleyin = !isNaN(props.scaleyin) ? props.scaleyin : 1;
    const durationin=!isNaN(props.durationin) ? props.durationin : 1000;
    const easingin=!isNaN(props.easingin) ? props.easingin : null;
    const callback = props.callback ? props.callback : ()=>null;
    const classNamer = props.className ? props.className : "ls-l";
    return (
        <img className={classNamer + " sliderImageTest"} onClick={()=>callback()}
             style={{top:top,left:left,transform:"rotate(" + rotate + "deg)",
                 msTransform:"rotate("+rotate+"deg)",
                 WebkitTransform:"rotate("+rotate+"deg)",
                 whiteSpace: "nowrap"}}
             data-ls={"offsetxin:"+offsetxin+";" +
                    "offsetyin:"+offsetyin+";" +
                    "offsetxout:"+offsetxout+";" +
                    "offsetyout:"+offsetyout+";" +
                    "delayin:"+delayin+";" +
                    "parallaxlevel:"+parallaxlevel+";" +
                    "rotatexin:"+rotatexin+";" +
                    "rotateyin:"+rotateyin+";" +
                    "scalexin:"+scalexin+";" +
                    "scaleyin:"+scaleyin+";"+
                    "durationin:"+durationin+";"+
                    "easingin:"+easingin+";"
             }
             src={src} alt={alt} />
    )
};

SliderImage.propTypes = {
    top:PropTypes.number,
    left:PropTypes.number,
    rotate:PropTypes.number,
    src:PropTypes.string,
    alt:PropTypes.string,
    offsetxin:PropTypes.number,
    offsetyin:PropTypes.number,
    offsetxout:PropTypes.number,
    delayin:PropTypes.number,
    parallaxlevel:PropTypes.number,
    rotatexin:PropTypes.number,
    rotateyin:PropTypes.number,
    scalexin:PropTypes.number,
    scaleyin:PropTypes.number,
    durationin:PropTypes.number,
    easingin:PropTypes.number,
    //callback:PropTypes.function,
};

export default SliderImage
